import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const Marquee = ({ animate = true, duration = 10, children }) => {
    return (_jsx("div", { className: 'marquee', children: animate ?
            (_jsxs("div", { className: "marquee-track", style: { animationDuration: `${duration}s` }, children: [children, children] })) :
            (_jsx("div", { className: "marquee-container", children: children })) }));
};
export default Marquee;
